import Vue from 'vue';
import App from './App.vue';
import VueAnalytics from 'vue-analytics'



// CSS imports
// import './../node_modules/bulma/css/bulma.css';
// import './../public/css/fontawesome.5.6.3.css';


// Router setup
// import router from './router'
import VueRouter from 'vue-router';
Vue.use(VueRouter);

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import Home from "./views/Home.vue";
import AboutUs from "./views/AboutUs.vue";
import Services from "./views/Services.vue";
import Products from "./views/Products.vue";
import RnD from './views/RnD.vue';
import RnDaaService from './views/RnDaaService.vue';
import RnDmindcore from './views/RnDmindcore.vue';
import Nyx from './views/Nyx.vue';
import Iris from './views/Iris.vue';
import Gallery from './views/Gallery.vue';
import Contact from './views/Contact';
// import i18n from './i18n'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      breadcrumb: [
        {
          name: '',
        }
      ]
    }
  },

  {
    path: '/aboutus',
    name: 'about us',
    component: AboutUs,
    meta: { 
      breadcrumb: [
        {
            name: 'Home Page',
            link: '/'
        },
        {
          name: 'About Us', 
        }
      ] 
    }
  },

  {
    path: '/services', 
    name: 'services', 
    component: Services, 
    meta: { 
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        { 
          name: 'Services', 
        } 
      ]
    } 
  },

  {
    path: '/products', 
    name: 'products', 
    component: Products, 
    meta: { 
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        {
          name: 'Products', 
        } 
      ] 
    } 
  },

  {
    path: '/rnd', 
    name: 'r&d', 
    component: RnD, 
    meta: { 
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        { 
          name: 'R&D', 
        } 
      ]
    } 
  },

  { 
    path: '/rnd/as-a-service', 
    name: 'r&d / as a service', 
    component: RnDaaService, 
    meta: { 
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        { 
          name: 'R&D', 
          link: '/rnd'
        }, 
        {
          name: 'As a Service', 
        }
      ] 
    } 
  },

  {
    path: '/rnd/mindcore',
    name: 'r&d / mindcore\'s r&d', 
    component: RnDmindcore, 
    meta: { 
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        { 
          name: 'R&D', 
          link: '/rnd'
        }, 
        {
          name: 'MindCore\'s R&D'
        }
      ]
    } 
  },

  { 
    path: '/rnd/mindcore/nyx',
    name: 'r&d / mindcore\'s r&d / Nyx ', 
    component: Nyx, 
    meta: { 
        breadcrumb: [
          {
            name: 'Home Page',
            link: '/'
          },
          { 
            name: 'R&D', 
            link: '/rnd'
          },
          {
            name: 'MindCore\'s R&D',
            link: '/rnd/mindcore'
          },
          {
            name: 'Nyx'
          }
        ] 
    } 
  },

  {
    path: '/rnd/mindcore/iris',
    name: 'r&d / mindcore\'s r&d / Iris ', 
    component: Iris, 
    meta: {
      breadcrumb: [
        {
          name: 'Home Page',
          link: '/'
        },
        { 
          name: 'R&D', 
          link: '/rnd'
        },
        {
          name: 'MindCore\'s R&D',
          link: '/rnd/mindcore'
        },
        {
          name: 'Iris'
        }
      ] 
    } 
  },
  
  {
    path: '/gallery', 
    name: 'gallery', 
    component: Gallery, 
    meta: { 
      breadcrumb: [
        {
            name: 'Home Page',
            link: '/'
        },
        {
          name: 'Gallery', 
        }
      ] 
    } 
  },

  {
    path: '/contact',
    name: 'contact us',
    component: Contact,
    meta: { 
      breadcrumb: [
        {
            name: 'Home Page',
            link: '/'
        },
        {
          name: 'Contact Us', 
        }
      ] 
    }  
  }
];

const router = new VueRouter({
  routes: routes
});

Vue.use(VueAnalytics, {
  id: 'UA-10859228-5',
  router
});

// Devop config
Vue.config.productionTip = false


new Vue({
  router,
  // i18n,
  render: h => h(App)
}).$mount('#app')
